const replaceOrAppend = <T>(predicate: (value: T) => boolean, item: T, array: T[]): T[] => {
  const index = array.findIndex(predicate)

  if (index === -1) return [...array, item]

  return array.map((element, elementIndex) => (elementIndex === index ? item : element))
}

export default replaceOrAppend
